module.exports = __webpack_public_path__ + "static/img/硅硐.815c97c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/硅硐.jpg
// module id = 191
// module chunks = 1